module.exports = __webpack_public_path__ + "img/phone_mock_up_front.759b4963.png";